var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-269 -2872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    transform: "translate(261 2880)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(322 2872)",
    fill: "#f36822"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(348 3007)",
    fill: "#1c3557"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chip",
    transform: "translate(305 2917.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(12.402 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    d: "M148.839,32.035H133.272v-2.2h4.2a.967.967,0,1,0,0-1.934h-4.2V25.7h2.916a4.04,4.04,0,0,0,2.876-1.191l6.359-6.359a3.032,3.032,0,1,0-1.367-1.367L137.7,23.143a2.119,2.119,0,0,1-1.508.625h-2.916V21.635a5.106,5.106,0,0,0-5.1-5.1h-2.133V7.976a3.034,3.034,0,1,0-1.934,0v8.559h-2.2v-4.2a.967.967,0,0,0-1.934,0v4.2h-2.2V.968a.967.967,0,1,0-1.934,0V16.535h-2.2v-4.2a.967.967,0,0,0-1.934,0v4.2h-2.2V13.619a4.04,4.04,0,0,0-1.191-2.876l-6.361-6.361a3.035,3.035,0,1,0-1.367,1.367l6.361,6.361a2.119,2.119,0,0,1,.625,1.508v2.916h-2.133a5.122,5.122,0,0,0-1.275.161.967.967,0,1,0,.482,1.873,3.184,3.184,0,0,1,.793-.1h22.734a3.17,3.17,0,0,1,3.167,3.167V44.369a3.185,3.185,0,0,1-.1.792.967.967,0,1,0,1.873.481,5.117,5.117,0,0,0,.16-1.273V42.235h8.559a3.034,3.034,0,1,0,0-1.934h-8.559V38.1h4.2a.967.967,0,0,0,0-1.934h-4.2v-2.2h15.567a.967.967,0,0,0,0-1.934Zm-2.844-17.378a1.1,1.1,0,1,1-.322.778A1.093,1.093,0,0,1,145.994,14.657ZM100.015,3.812a1.1,1.1,0,1,1,0-1.556A1.1,1.1,0,0,1,100.015,3.812ZM125.072,6.2a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,125.072,6.2Zm19.634,33.968a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,144.705,40.169Z",
    transform: "translate(-96.206 -0.001)",
    fill: "#6c6a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(0 19.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M52.713,193.5a3.037,3.037,0,0,0-3.493-.57l-6.361-6.361a2.119,2.119,0,0,1-.625-1.508v-2.916h2.133a5.119,5.119,0,0,0,1.274-.161.967.967,0,1,0-.482-1.873,3.182,3.182,0,0,1-.792.1H21.634a3.17,3.17,0,0,1-3.167-3.167V154.307a3.18,3.18,0,0,1,.1-.792.967.967,0,1,0-1.873-.482,5.111,5.111,0,0,0-.161,1.274v2.133H7.975a3.034,3.034,0,1,0,0,1.934h8.559v2.2h-4.2a.967.967,0,1,0,0,1.934h4.2v2.2H.967a.967.967,0,0,0,0,1.934H16.534v2.2h-4.2a.967.967,0,0,0,0,1.934h4.2v2.2H13.618a4.04,4.04,0,0,0-2.876,1.191l-6.359,6.359a3.031,3.031,0,1,0,1.368,1.367l6.359-6.359a2.119,2.119,0,0,1,1.509-.625h2.916v2.133a5.106,5.106,0,0,0,5.1,5.1h2.133V190.7a3.034,3.034,0,1,0,1.934,0V182.14h2.2v4.2a.967.967,0,0,0,1.934,0v-4.2h2.2v15.567a.967.967,0,1,0,1.934,0V182.141h2.2v4.2a.967.967,0,0,0,1.934,0v-4.2h2.2v2.916a4.04,4.04,0,0,0,1.191,2.876l6.361,6.361a3.033,3.033,0,1,0,4.86-.8ZM5.1,158.507a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,5.1,158.507ZM3.811,184.018a1.1,1.1,0,1,1,.322-.778A1.093,1.093,0,0,1,3.811,184.018Zm22.023,9.556a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,25.834,193.574Zm25.512,2.844a1.1,1.1,0,1,1,0-1.555A1.1,1.1,0,0,1,51.346,196.419Z",
    transform: "translate(0 -152.306)",
    fill: "#6c6a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(22.734 21.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M196.891,177.057a4.67,4.67,0,0,0-3.583-4.388,3.3,3.3,0,0,0,.1-.778,3.727,3.727,0,0,0-3.873-3.55,4.022,4.022,0,0,0-2.906,1.207,4.022,4.022,0,0,0-2.906-1.207,3.726,3.726,0,0,0-3.873,3.55,3.3,3.3,0,0,0,.1.778,4.67,4.67,0,0,0-3.583,4.388,4.246,4.246,0,0,0,1.018,2.751,4.781,4.781,0,0,0-1.018,2.932,4.979,4.979,0,0,0,2.325,4.131v0a4.279,4.279,0,0,0,4.454,4.067,4.613,4.613,0,0,0,3.488-1.541,4.613,4.613,0,0,0,3.488,1.541,4.308,4.308,0,0,0,4.445-3.816,4.519,4.519,0,0,0,2.334-3.868,4.358,4.358,0,0,0-1.345-3.1A4.359,4.359,0,0,0,196.891,177.057Zm-3.422,3.955a2.579,2.579,0,0,1,1.488,2.245,2.473,2.473,0,0,1-.852,1.818,4.34,4.34,0,0,0-2.542-2.047.967.967,0,1,0-.58,1.845,2.193,2.193,0,0,1,1.648,2,2.556,2.556,0,0,1-5.042,0v-6.2a2.354,2.354,0,0,1,2.521-2.133.967.967,0,1,0,0-1.934,4.726,4.726,0,0,0-2.521.716v-1.235a.967.967,0,1,0-1.934,0v5.367a4.6,4.6,0,0,0-1.068-.495.967.967,0,0,0-.58,1.845,2.193,2.193,0,0,1,1.648,2v2.067a2.556,2.556,0,0,1-5.042,0,1.949,1.949,0,0,1,.6-1.38.967.967,0,0,0-1.363-1.371,4.113,4.113,0,0,0-.6.749,2.949,2.949,0,0,1-.967-2.132,3.293,3.293,0,0,1,2.734-3.06.967.967,0,0,0-.432-1.885,5.89,5.89,0,0,0-1.774.723,2.333,2.333,0,0,1-.528-1.461,2.9,2.9,0,0,1,3.078-2.649h.026a.966.966,0,0,0,.82-1.476c-.007-.012-.014-.024-.022-.035l-.013-.017c-.015-.021-.03-.042-.047-.061v0a1.435,1.435,0,0,1-.354-.927,1.972,1.972,0,0,1,3.879,0,.967.967,0,1,0,1.934,0,1.972,1.972,0,0,1,3.879,0,1.36,1.36,0,0,1-.145.608,5.369,5.369,0,0,0-1.587.4.967.967,0,0,0,.751,1.782,3.49,3.49,0,0,1,1.337-.27h.053a2.9,2.9,0,0,1,3.078,2.649,2.579,2.579,0,0,1-1.488,2.245.967.967,0,0,0,0,1.71Z",
    transform: "translate(-176.357 -168.34)",
    fill: "#6c6a6c"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.8cb05af9b15b28877ec98b1bc49bd934.svg";
export { ForwardRef as ReactComponent };